module.exports = __webpack_public_path__ + "static/History_Channel_3D-de359ba00d2fe086a52d7efd35644c1a.mp4";